import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { UserService } from '../../../services/user.service';
import { Toaster } from 'ngx-toast-notifications';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EnvironmentInstanceService } from '../../../environment-instance.service';
import { Roles } from '../all-users/all-users.component';
import { UserDataAttributes } from '../../../models/registerUser';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<EditUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService,
    private toaster: Toaster,
    private fb: FormBuilder,
    private envService: EnvironmentInstanceService
  ) { }

  accountDetailsForm: FormGroup;
  selectedRole;
  
  public userRoles: Roles[] = [];

  public userGroups: any = [];

  public selectedGroups: string[] = []

  ngOnInit() {

    this.userRoles = this.envService.roles

    this.userGroups = this.envService.groups

    this.selectedRole = this.data.data.role

    this.createForms()

  }

  createForms() {
    console.log(this.data)

    // user links form validations
    this.accountDetailsForm = this.fb.group({
      username: new FormControl(this.data.data.username, Validators.compose([
        // UsernameValidator.validUsername,
        Validators.maxLength(25),
        Validators.minLength(5),
        // Validators.pattern('^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$'),
        Validators.required
      ])),
      email: new FormControl(this.data.data.email, Validators.compose([
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$")
      ])),
      role: new FormControl(this.data.data.role, Validators.compose([
      ])),
      groups: new FormControl([] , Validators.compose([
      ]))
    })

    for (const group of this.userGroups) {
      this.accountDetailsForm.addControl(group.value, new FormControl(''));
    }
    for (const group of this.data.data.groups) {
      this.accountDetailsForm.controls[group].setValue(group);
      this.updateSelectedGroups(group)
    }
  }

  updateSelectedGroups(groupValue: string) {
    const control = this.accountDetailsForm.get(groupValue);
  
    if (control) {
      console.log(control)
      console.log(this.selectedGroups)
      if (control.value) {
        this.selectedGroups.push(groupValue);
      } else {
        const index = this.selectedGroups.indexOf(groupValue);
        if (index > -1) {
          this.selectedGroups.splice(index, 1);
        }
      }
    }
  }

  submit(value: any) {
    let username = this.accountDetailsForm.value.username;
    let password = this.accountDetailsForm.value.password;
    let email = this.accountDetailsForm.value.email;
    let role = this.accountDetailsForm.value.role;
    let groups = this.selectedGroups;


    // instantiate the model RegisterUser
    let registerObject;
    registerObject= {data :
      {
      type: 'user',
      id: this.data.id,
      attributes: {
      user: {
        // username: username,
        // password: password,
        // email: email,
        is_staff: false,
        role: role,
        is_active: true
      },
      groups: groups
    }
  }
    }
    this.userService.patchUser(registerObject, this.data.id)
    .subscribe(
      res => {
      },
      error => {
        if (Array.isArray(error)) {
          error.forEach(err => {
            this.toaster.open({
              caption: `Error in editing user`,
              text: err.detail,
              type: `warning`,
            });
          })
        } else {
          this.toaster.open({
            caption: `Error in editing user`,
            text: error.detail,
            type: `warning`,
          });
        }
      },
      () => {
        this.toaster.open({
          caption: `Successfully edited user`,
          text: `User has been updated`,
          type: `success`
        });
        this.dialogRef.close({state: 'done'});
      })
  }

}
